import { CloseIcon, LeftArrowIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import * as React from 'react';

import { Button } from '../button/button.component';
import Dialog from '../dialogs';
import { FooterProps, HeaderProps, ModalWrapperProps } from './modal.types';

export const ModalWrapper = ({ children, ...otherProps }: ModalWrapperProps): JSX.Element => (
  <Dialog nested={true} {...otherProps}>
    <div className="bg-white rounded-lg p-32">{children}</div>
  </Dialog>
);

export const Footer = ({
  mainLabel,
  secLabel,
  onMainClick,
  onSecClick,
  status = 'primary',
  disabled,
}: FooterProps): JSX.Element => {
  return (
    <div className="flex h-48 mb-24 justify-end">
      {secLabel ? (
        <Button status="secondary" className="mr-12 min-w-107 justify-center" onClick={onSecClick}>
          {secLabel}
        </Button>
      ) : null}
      {mainLabel ? (
        <Button
          disabled={disabled}
          status={status}
          size="lg"
          className="justify-center"
          onClick={onMainClick}
        >
          {mainLabel}
        </Button>
      ) : null}
    </div>
  );
};

export const Header = ({
  title,
  onCloseBtnClick,
  onBackBtnClick,
  className,
  backClassName,
  closeClassName,
}: HeaderProps): JSX.Element => {
  return (
    <div
      className={classNames({
        'flex justify-between items-center': true,
        [className || '']: !!className,
      })}
    >
      <div className="flex items-center">
        {onBackBtnClick ? (
          <button
            onClick={onBackBtnClick}
            aria-label="Back button"
            className={classNames({
              'text-gray-500 text-xs': true,
              [backClassName || '']: !!backClassName,
            })}
          >
            <LeftArrowIcon />
          </button>
        ) : null}
        {title ? <h3 className="font-medium leading-32">{title}</h3> : null}
      </div>
    </div>
  );
};
